<div class="container body">
  <div class="main_container">
    <app-menu *ngIf="isLogin() == true"></app-menu>
    <div class="w-[102%]  flex justify-center" [ngClass]="isRootRoute ? '' : 'ml-14'">

      <router-outlet></router-outlet>
    </div>
  </div>
</div>